module.exports = __webpack_public_path__ + "img/desjardins_carrefour.67bef5b9.png";